import Recat, { Component } from "react";
import { connect } from "react-redux";
import { XIcon } from "@heroicons/react/outline";
import LocaleStrings from "../../../languages/index";
import AllPublishedItems from "./Allpublisheditems/index";
import ForAuctionItems from "./ForAuctionItems/index";
import ForSaleItems from "./ForSaleItems/index";
import UnapprovedItems from "./UnapprovedItems/index";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

class ProductmanagementlistTabs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tabIndextoShow: 1,
    };
  }

  componentDidMount() {}

  componentDidUpdate() {}

  // On Tabs change
  onTabsChange = (e, tabindex, callfrom) => {
    if (callfrom === "lg") {
      // For tabs
      this.setState({ tabIndextoShow: parseInt(tabindex) });
    } else {
      // For Select box
      this.setState({ tabIndextoShow: parseInt(e.target.value) });
    }
  };

  onProductTabSelect(e, href, position, screen) {
    if (screen == "sm") {
      if (e.target.value == "All Published Items") {
        this.props.history.push("/dashboard/productmanagement/allitems");
        this.setState({ tabIndextoShow: parseInt(e.target.value) });
      } else if (e.target.value == "For Sale") {
        this.props.history.push("/dashboard/productmanagement/forsale");
        this.setState({ tabIndextoShow: parseInt(e.target.value) });
      } else if (e.target.value == "For Auction") {
        this.props.history.push("/dashboard/productmanagement/forauction");
        this.setState({ tabIndextoShow: parseInt(e.target.value) });
      } else if (e.target.value == "Unapproved") {
        this.props.history.push("/dashboard/productmanagement/unapproved");
        this.setState({ tabIndextoShow: parseInt(e.target.value) });
      }
    } else {
      this.setState({ tabIndextoShow: parseInt(position) });
      this.props.history.push("/dashboard/productmanagement/" + href);
    }
  }

  render() {
    var selectedTab = "";
    return (
      <>
        <div className="px-6 text-2xl font-semibold text-secondary mb-6">
          {LocaleStrings.prod_mangement_heading}
        </div>

        <div className="sm:hidden">
          <label htmlFor="tabs" className="sr-only">
            Select a tab
          </label>
          <select
            id="tabs"
            name="tabs"
            className="block w-full focus:ring-primary focus:border-primary border-ternary rounded-md"
            // defaultValue={this.props.tabs.find((tab) => tab.current).name}
            onChange={(e) => this.onProductTabSelect(e, "", "", "sm")}>
            {this.props.tabs.map((tab) => (
              <option
                // key={tab.name} value={tab.tabindex}

                selected={
                  this.props.history.location.pathname ==
                    "/dashboard/productmanagement/allitems" &&
                  tab.href == "allitems"
                    ? "selected"
                    : this.props.history.location.pathname ==
                        "/dashboard/productmanagement/forsale" &&
                      tab.href == "forsale"
                    ? "selected"
                    : this.props.history.location.pathname ==
                        "/dashboard/productmanagement/forauction" &&
                      tab.href == "forauction"
                    ? "selected"
                    : this.props.history.location.pathname ==
                        "/dashboard/productmanagement/unapproved" &&
                      tab.href == "unapproved"
                    ? "selected"
                    : ""
                }>
                {tab.name}
              </option>
            ))}
          </select>
        </div>

        <div className="hidden sm:block">
          {/* <div className="xs:block"> */}
          <nav className="relative z-0 rounded-lg flex  pl-5" aria-label="Tabs">
            {this.props.tabs.map((tab, tabIdx) => (
              <span
                style={{ marginRight: "20px", borderRadius: "6px" }}
                key={tab.name}
                className={classNames(
                  this.state.tabIndextoShow === tab.position
                    ? "text-secondary"
                    : "text-ternary hover:text-secondary",
                  // tabIdx === 0 ? 'rounded-l-lg' : '',
                  // tabIdx === this.props.tabs.length - 1 ? 'rounded-r-lg' : '',
                  "cursor-pointer group relative min-w-0 flex-1 overflow-hidden bg-custWhite py-4 px-4 text-xs font-normal text-center hover:bg-quaternary focus:z-10 "
                )}
                aria-current={
                  this.state.tabIndextoShow === tab.position
                    ? "page"
                    : undefined
                }
                onClick={(e) =>
                  this.onProductTabSelect(e, tab.href, tab.position, "lg")
                }>
                <span>{tab.name}</span>
                <span
                  aria-hidden="true"
                  className={classNames(
                    this.props.history.location.pathname ==
                      "/dashboard/productmanagement/allitems" &&
                      tab.href == "allitems"
                      ? "bg-primary"
                      : this.props.history.location.pathname ==
                          "/dashboard/productmanagement/forsale" &&
                        tab.href == "forsale"
                      ? "bg-primary"
                      : this.props.history.location.pathname ==
                          "/dashboard/productmanagement/forauction" &&
                        tab.href == "forauction"
                      ? "bg-primary"
                      : this.props.history.location.pathname ==
                          "/dashboard/productmanagement/unapproved" &&
                        tab.href == "unapproved"
                      ? "bg-primary"
                      : "bg-transparent",
                    "absolute inset-x-0 bottom-0 h-0.5"
                  )}
                />
              </span>
            ))}
          </nav>
        </div>

        {/* <div className="py-6 px-6">
               
                    <div>
                        <div className="sm:hidden">
                            <label htmlFor="tabs" className="sr-only">
                            Select a tab
                            </label>
                            <select
                            id="tabs"
                            name="tabs"
                            className="block w-full focus:ring-primary focus:border-primary border-ternary rounded-md"
                            defaultValue={this.props.tabs.find((tab) => tab.current).name}
                            onChange = {(e) =>
                                this.onTabsChange(e,0,'sm')
                            }
                            >
                            {this.props.tabs.map((tab) => (
                                
                                <option key={tab.name} value={tab.tabindex}  selected={((this.state.tabIndextoShow === tab.tabindex) ? 'selected' : '')} >{tab.name}</option>
                            ))}
                            </select>
                        </div>
                        <div className="hidden sm:block">
                            <nav className="relative z-0 rounded-lg flex  " aria-label="Tabs">
                            {this.props.tabs.map((tab, tabIdx) => (
                                <span
                                style={{marginRight:'20px', borderRadius:'6px'}}
                                key={tab.name}
                                className={classNames(
                                    (this.state.tabIndextoShow === tab.tabindex ) ? 'text-secondary' : 'text-ternary hover:text-secondary',
                                    tabIdx === 0 ? 'rounded-l-lg' : '',
                                    tabIdx === this.props.tabs.length - 1 ? 'rounded-r-lg' : '',
                                    'cursor-pointer group relative min-w-0 flex-1 overflow-hidden bg-custWhite py-4 px-4 text-xs font-normal text-center hover:bg-quaternary focus:z-10 '
                                )}
                                aria-current={(this.state.tabIndextoShow === tab.tabindex ) ? 'page' : undefined}
                                onClick = {(e) =>
                                    this.onTabsChange(e,tab.tabindex,'lg')
                                }
                                >
                                <span>{tab.name}</span>
                                <span
                                    aria-hidden="true"
                                    className={classNames(
                                        (this.state.tabIndextoShow === tab.tabindex ) ? 'bg-primary' : 'bg-transparent',
                                    'absolute inset-x-0 bottom-0 h-0.5'
                                    )}
                                />
                                </span>
                            ))}
                            </nav>
                        </div>
                        <div className="">
                            <div className="mt-5">
                                    <div className={this.state.tabIndextoShow === 1 ? '' : 'hidden'} ><AllPublishedItems/></div>
                                    <div className={this.state.tabIndextoShow === 2 ? '' : 'hidden'} ><ForSaleItems/></div>
                                    <div className={this.state.tabIndextoShow === 3 ? '' : 'hidden'} ><ForAuctionItems/></div>
                                    <div className={this.state.tabIndextoShow === 4 ? '' : 'hidden'} >
                                        <UnapprovedItems/>
                                        </div>
                            </div>
                        </div>
                    </div>
                </div> */}
      </>
    );
  }
}

function mapStateToProps(state) {
  var { session, user } = state;
  return {
    session,
    user,
    isLoggedIn: state.isLoggedIn,
    sidebarSelectedMenu: state.sidebarSelectedMenu,
    language: state.language,
    tabs: state.ProductManagementTabs,
  };
}

export default connect(mapStateToProps, {})(ProductmanagementlistTabs);
